import * as Actions from '../actions'

const initialState = {
  success: false,
  isSubmitting: false,
  error: {
    username: null,
    password: null,
  },
}

const register = function (state = initialState, action) {
  switch (action.type) {
    case Actions.CHECK_PLACE: {
      return {
        ...initialState,
        isSubmitting: true,
      }
    }
    case Actions.CHECK_EMAIL: {
      return {
        ...initialState,
        isSubmitting: true,
      }
    }
    case Actions.REGISTER: {
      return {
        ...initialState,
        isSubmitting: true,
      }
    }
    case Actions.REGISTER_SUCCESS: {
      return {
        ...initialState,
        success: true,
        isSubmitting: false,
      }
    }
    case Actions.REGISTER_ERROR: {
      return {
        success: false,
        error: action.payload,
        isSubmitting: false,
      }
    }
    case Actions.CHECK_EMAIL_PROCEED_WITH_CAUTION: {
      return {
        ...initialState,
        isSubmitting: false,
      }
    }
    case Actions.CHECK_PLACE_PROCEED_WITH_CAUTION: {
      return {
        ...initialState,
        isSubmitting: false,
      }
    }
    case Actions.CHECK_PLACE_ERROR: {
      return {
        ...initialState,
        isSubmitting: false,
      }
    }
    case Actions.CHECK_EMAIL_ERROR: {
      return {
        ...initialState,
        isSubmitting: false,
      }
    }
    default: {
      return state
    }
  }
}

export default register
